module.exports = __webpack_public_path__ + "static/media/city.149317d7.svg";